import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { organizationsApi } from '../../api/organizations';
import { GQLArgs } from '../../types';

type UpdateOrgResponse = { updateOrganization: { slug: string; active: boolean } };

export const useMutationUpdateOrganization = (args?: GQLArgs<UpdateOrgResponse>) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<UpdateOrgResponse | undefined>();

  const mutation = useCallback(
    async ({
      variables,
    }: {
      variables: { organizationSlug: string; organizationActive: boolean };
    }) => {
      setLoading(true);
      try {
        const res = await organizationsApi.update(variables.organizationSlug, {
          active: variables.organizationActive,
        });
        const shaped: UpdateOrgResponse = {
          updateOrganization: { slug: res.data.slug, active: res.data.active },
        };
        setData(shaped);
        args?.onCompleted?.(shaped);
        toast.success('Settings has been updated', { autoClose: 5000 });
        return shaped;
      } catch (err: any) {
        args?.onError?.(err);
      } finally {
        setLoading(false);
      }
    },
    [args],
  );

  return { mutation, data, loading, error: undefined };
};
